module.exports = __webpack_public_path__ + "static/media/icon-gestao-estoque.67e0f0b3.png";